import { Options, Vue } from "vue-class-component";
import { VNode, h } from "vue";
import { wiki } from "@/store/modules/wikimap/wiki-list";
import { dangisWiki } from "@/config/host.config";
import { isWiki } from "@/config/feature-flags";
import { AccessToken } from "@/api/accessDecoder";
import { isServerReachable } from "@/services/connectivity";

@Options({
  name: "wiki-map",
  components: {},
  render: function (): VNode {
    return h("div", this.$slots.default());
  },
})
export default class WikiMap extends Vue {
  wikiInterval!: ReturnType<typeof setTimeout>;
  wiki = wiki();

  async createWikiList(): Promise<void> {
    if (!isWiki || !isServerReachable()) return;
    const url = dangisWiki.mainAPI;
    const params = {
      "match[deleted][value]": false,
      "match[show]": true,
    };

    try {
      const wikiRes = await this.$axios.get(url, { params });
      if (wikiRes.status === 200) {
        this.wiki.setWikiDots(wikiRes.data);
      }
    } catch (error) {
      this.$error(error);
    }
  }

  mounted(): void {
    if (!isWiki) return;
    setTimeout(() => {
      this.createWikiList();
    }, this.$second(3));
    this.wikiInterval = setInterval(() => {
      if (AccessToken.isAuthorized) this.createWikiList();
    }, this.$second(10));
  }

  unmounted(): void {
    clearInterval(this.wikiInterval);
  }
}
